export const ApiUrls = {
	getAllEventCategories: '/api/EventCategory/getList',
	getAllEventCategoryDetail: '/api/EventCategory/getById',
	insertEventCategory: '/api/EventCategory/insert',
	updateEventCategory: '/api/EventCategory/update',
	deleteEventCategory: '/api/EventCategory/delete',
	getEventCategory: '/eventCategory/getAllCategory',
	getRoles: '/api/User/getRoles',
	getRoleById: '/api/User/getRoleById',
	updateRole: '/api/User/updateRole',
	deleteRole: '/api/User/deleteRole',
	insertRole: '/api/User/createRole',
	getUsers: '/api/User/getList',
	getUser: '/api/User/getById',
	updateUserImage:'/api/User/updateUserImage/',
	getUserImage:'/api/User/getUserImage/',
	getUserNotification: '/api/User/GetUserNotification',
	updateUserNotification: '/api/User/updateUserNotification',
	getAllPermissions: '/api/User/getAllPermissions',
	insertUser: '/api/User/createUser',
	validateInvitedUser: '/api/UserInvitation/ValidateEmail',
	inviteUser: '/api/UserInvitation/InvitePeople',
	updateUser: '/api/User/update',
	deleteUser: '/api/User/delete',
	getUserPermissions: '/user/getAllPermissions',
	getUserPermission: '/user/getPermission',
	deleteUserPermission: '/user/deletePermission',
	getAllOrganizations: '/api/Organization/getList',
	getAllOrganizationsDetails: '/api/Organization/getById',
	updateOrganization: '/api/Organization/update',
	deleteOrganization: '/api/Organization/delete',
	insertOrganization: '/api/Organization/insert',
	getTournaments: '/api/Tournament/getList',
	getTournament: '/api/Tournament/getById',
	deleteTournament: '/api/Tournament/delete',
	insertTournament: '/api/Tournament/insert',
	updateTournament: '/api/Tournament/update',
	getPriceCategories: '/api/PriceCategory/getList',
	getPriceCategory: '/api/PriceCategory/getById',
	deletePriceCategory: '/api/PriceCategory/delete',
	insertPriceCategory: '/api/PriceCategory/insert',
	updatePriceCategory: '/api/PriceCategory/update',
	getEvents: '/api/Event/getList',
	getEvent: '/api/Event/getById',
	deleteEvent: '/api/Event/delete',
	insertEvent: '/api/Event/insert',
	updateEvent: '/api/Event/update',
	getSubEvents: '/api/SubEvent/getList',
	getSubEvent: '/api/SubEvent/getById',
	deleteSubEvent: '/api/SubEvent/delete',
	insertSubEvent: '/api/SubEvent/insert',
	updateSubEvent: '/api/SubEvent/update',
	getConfigTypes: '/api/ConfigurationType/getList',
	getConfigType: '/api/ConfigurationType/getById',
	deleteConfig: '/settings/deleteConfig',
	updateConfig: '/api/ConfigurationType/update',
	getLookups: '/settings/getAllLookups',
	getLookup: '/settings/getLookup',
	deleteLookup: '/settings/deleteLookup',
	getTemplates: '/api/Template/getList',
	getAllSelectedTemplates: '/api/Template/getAllSelectedTemplates',
	updateSelectedTemplate: '/api/Template/updateSelectedTemplate',
	getChipData: '/api/Template/getChipData',
	getTemplate: '/settings/getTemplate',
	deleteTemplate: '/api/Template/delete',
	getBookings: '/api/Booking/getBookings',
	getBooking: '/booking/getBooking',
	deleteBooking: '/booking/deleteBooking',
	getPayments: '/payment/getAllPayments',
	getPayment: '/payment/getPayment',
	deletePayment: '/payment/deletePayment',
	login: '/api/Auth/login',
	loginsso: '/api/Auth/sso-login',
	//forgotPassword: '/auth/forgotPassword',
	forgotPassword: '/api/Auth/ForgotPassword',
	//changePassword: '/auth/changePassword',
	resetPassword: '/api/Auth/ResetPassword',
	signupUser: '/api/UserInvitation/SignupUser',
	passwordOtp: '/api/Auth/OTPVerify',
	getAllVenues: '/api/VenueDetails/getList',
	getVenueDetails: '/api/VenueDetails/getById',
	deleteVenue: '/api/VenueDetails/delete',
	insertVenue: '/api/VenueDetails/insert',
	updateVenue: '/api/VenueDetails/update',
	getAllBlocks: '/api/BlockDetails/getList',
	deleteBlock: '/api/BlockDetails/delete',
	getEnums: '/api/Enum/getList',
	deleteEnum: '/api/Enum/delete',
	insertEnum: '/api/Enum/insert',
	updateEnum: '/api/Enum/update',
	getEnumById: '/api/Enum/getById',
	getEnumItems: '/api/Enum/getEnumItemList',
	insertBlock: '/api/BlockDetails/insert',
	updateBlock: '/api/BlockDetails/update',
	getBlockDetails: '/api/BlockDetails/getById',
	getSeatMapping: '/api/VenueSeatMapping/getList',
	insertBlockSeatMapper: '/api/VenueSeatMapping/insert',
	updateBlockSeatMapper: '/api/VenueSeatMapping/update',
	getLangList: "/api/Language/getList",
	createSeatMapping: '/api/EventSeatsMapping/insert',
	updateSeatMapping: '/api/EventSeatsMapping/update',
	createUpdateSeatMapping: '/api/EventSeatsMapping/InsertOrUpdate',
	getEventSeatMapping: '/api/EventSeatsMapping/getList',
	deleteEventSeatMapping: '/api/EventSeatsMapping/delete',
	insertImage: '/api/ImageManager/InsertImage',
	updateImage: '/api/ImageManager/UpdateImage',
	getImageById: '/api/ImageManager/getById',
	deleteImage: '/api/ImageManager/delete',
	getImageList: '/api/ImageManager/getList',
	getImage: '/api/ImageManager/GetImage',
	createMailTemplate: '/api/Template/create',
	updateMailTemplate: '/api/Template/update',
	getMailTemplateById: '/api/Template/getById',
	getAllTicketTemplate: '/api/TicketTemplate/getList',
	createTicketTemplate: '/api/TicketTemplate/insert',
	updateTicketTemplate: '/api/TicketTemplate/update',
	getTicketTemplateById: '/api/TicketTemplate/getById',
	insertFaq: '/api/Faq/insert',
	deleteFaq: '/api/Faq/delete',
	updateFaq: '/api/Faq/update',
	getFaqById: '/api/Faq/getById',
	getFaqList: '/api/Faq/GetFaqList',
	getAllApplication: '/api/CustomerApplication/GetList',
	updateApplicationStatus: '/api/CustomerApplicationStatus/UpdateApplicationStatus',
	getEventCountStatus: '/api/Event/getEventsCountByStatus',
	getBookingCount: '/api/Booking/getBookingCount',
	createCategory: '/api/Category/create',
	categoryGetList: '/api/Category/getList',
	categoryById: '/api/Category/getById',
	updateCategory: '/api/Category/update',
	deleteCategory: '/api/Category/delete',
	createWorkflowGroup: '/api/WorkFlowGroups/create',
	updateWorkflowGroup: '/api/WorkFlowGroups/update',
	getWorkFlowGroupById: '/api/WorkFlowGroups/getById',
	workflowGroupList: '/api/WorkFlowGroups/getList',
	deleteWorkflowGroup: '/api/WorkFlowGroups/delete',
	workFlowList: '/api/WorkFlowDetails/getList',
	workflowDetailsGroupList: '/api/WorkFlowGroups/GetAllWorkFlowGroups',
	workflowDetailsCategoryList: '/api/Category/GetAllCategory',
	worflowDetailsGetById: '/api/WorkFlowDetails/getByCategoryId',
	createWorkflowDetails: '/api/WorkFlowDetails/saveWorkFlowDetails',//'/api/WorkFlowDetails/create',
	updateWorkflowDeatils: '/api/WorkFlowDetails/update',
	deleteWorkflowDetails: '/api/WorkFlowDetails/delete',
	createLookUp: '/api/Lookup/CreateLookupItemAsync',
	updateLookUp: '/api/Lookup/UpdateLookupItemAsync',
	getLookUpByParentId: '/api/Lookup/GetLookupItemByParentIdAsync',
	getLookupById: '/api/Lookup/GetLookupItemByIdAsync',
	getLookupItems: '/api/Lookup/GetLookupItemsAsync',
	GetParticipationTypesLookUp: '/api/Lookup/GetParticipationTypesLookUp',
	deleteLookupItems: '/api/Lookup/DeleteLookupItemAsync',
	getDelegations: '/api/Delegation/getList',
	createDelegations: '/api/Delegation/create',
	getDelegationById: '/api/Delegation/getById',
	UpdateDelegations: '/api/Delegation/update',
	DeleteDelegations: '/api/Delegation/delete',
	RevokeDelegations: '/api/Delegation/revoke',
	getDelegationPermission: '/api/Delegation/permissions',
	assignDelegationPermission: '/api/Delegation/assignPermission',
	removeDelegationPermission: '/api/Delegation/removePermission',
	getAllDelegatablePermissions: '/api/User/GetAllDelegatablePermissions',
	userDelegations: '/api/Delegation/userDelegations',
	getAdministrationList: '/api/Administration/getList',
	createAdministration: '/api/Administration/createAdministration',
	getAdministrationById: '/api/Administration/getById',
	updateAdministration: '/api/Administration/updateAdministration',
	deleteAdministration: '/api/Administration/deleteAdministration',
	getDepartmentList: '/api/Department/getList',
	getWorkflowByDepartment: '/api/WorkFlowDetails/getByDepartment',
	getusersbydept: '/api/User/getUserByDepartment',
	getUserByRoleAndDepartment: '/api/User/getUserByRoleAndDepartment',
	getDepartmentByLoggedInUser: '/api/Department/getDepartmentByLoggedInUser',
	createDepartment: '/api/Department/createDepartment',
	getDepartmentById: '/api/Department/getById',
	updateDepartment: '/api/Department/updateDepartment',
	deleteDepartment: '/api/Department/deleteDepartment',
	getEmailConfiguration: '/api/EmailConfiguration/getEmailConfiguration',
	updateEmailConfiguration: '/api/EmailConfiguration/updateEmailConfiguration',
	getTasksMeetings: '/api/Meeting/GetTasksMeetings',
	gettaskStatusLookup: '/api/Lookup/GetTaskStatusLookUp',
	sendTasks: '/api/Document/SaveSharedRecommendations',
	sharedUserRec: '/api/Document/GetSharedRecDetails',
	deleteRecommendation: '/api/Document/DeleteSharedRecommendations',
	updateRecommenation: '/api/Meeting/UpdateRecommendations',
	createPomReportTemplate: '/api/Template/createUpdateParticipantReportTemplate',
	getAllParticipantReportTemplate: '/api/Template/getAllParticipantReportTemplate',
	getAllSelectedTemplate: '/api/Template/getAllSelectedParticipantReportTemplate',
	UpdateSelectedPRTemplate: '/api/Template/UpdateSelectedPRTemplate',
	downloadTemplate: '/api/Template/downloadTemplate',
	createTranslationTemplate: '/api/Template/createUpdateTranslationTemplate',
	getAllTranslationTemplate: '/api/Template/getAllTranslationTemplate',
	deleteTranslationTemplate: '/api/Template/deleteTranslationTemplate',
	deleteParticipantReportTemplate: '/api/Template/deleteParticipantReportTemplate',
	getAllSelectedTranslationTemplate: '/api/Template/getAllSelectedTranslationTemplate',
	UpdateSelectedTranslationTemplate: '/api/Template/UpdateSelectedTranslationTemplate',
	GetAllConfiguration: '/api/SchedulerConfiguration/getConfigurationList',
	GetConfigurationByCode: '/api/SchedulerConfiguration/getConfiguration',
	CreateConfiguration: '/api/SchedulerConfiguration/createConfiguration',
	UpdateConfiguration: '/api/SchedulerConfiguration/updateConfiguration',
	DeleteConfiguration: '/api/SchedulerConfiguration/deleteConfiguration',
	GetPrecedentAllDocuments: '/api/Document/GetAllDocument',
	GetPrecedentDocumentDetails: '/api/PrecedentDashboard/GetDocumentDetails',
	GetPrecedentDashboardCounts: '/api/PrecedentDashboard/GetPrecedentDashboardCounts',
	GetStatusCounts: '/api/PrecedentDashboard/GetDocumentStatusCount',
	GetPrecedentCategoryTwoCounts: '/api/PrecedentDashboard/GetPrecedentCategoryTwoCounts',
	GetParticipationMinutesPerDep: '/api/PrecedentDashboard/GetParticipationMinutesPerDep',
	GetParticipantNamesPerDep: '/api/PrecedentDashboard/GetParticipantNamesPerDep',
	GetRecommendationsCount: '/api/PrecedentDashboard/GetRecommendationsCount',
	organizationalHierarchy: '/api/Lookup/GetLookUpHierarchy',
	CallAiOnApproval: '/api/Ai/CallAiOnApproval',
	SearchAndAnswerAi: '/api/Ai/SearchAndAnswerAi',
	SearchAi: '/api/Ai/SearchAi',
	DeleteAi: '/api/Ai/DeleteAi',
	updateSubjectWithLevels: '/api/Lookup/UpdateSubjectWithLevels',
	getConfidentialityLookupItems: '/api/Lookup/GetConfidentialityLookUp',
	getDelegationToken: '/api/Auth/delegation-token',
	FilterDropDownValues: '/api/PrecedentDashboard/GetPrecedentDashboardFilterDropDownValues',
	ExportPrecedentDashboardData: '/api/PrecedentDashboard/ExportPrecedentDashboardData',
	GetRecommendationDetails: "/api/PrecedentDashboard/GetRecommendationDetails",
	GetPrecedentCategoryTwoMonthlyCounts: "/api/PrecedentDashboard/GetPrecedentCategoryTwoMonthlyCounts",
	DownloadReport: "/api/PrecedentDashboard/ExportPrecedentDashboardData",
	GetDocumentWorkFlowDetails: "/api/PrecedentDashboard/GetDocumentWorkFlowDetails",
	getGetDocumentPomDetails: "/api/PrecedentDashboard/GetDocumentPomDetails",
	GetDashboardSubject: '/api/PrecedentDashboard/GetDashboardSubject',
	GetDashboardTwoCounts: '/api/DashboardTwo/GetDashboardTwoCounts',
	GetDashboardTwoRecommendationsCount: '/api/DashboardTwo/GetRecommendationsCount',
	GetDashboardTwoParticipantNamesPerDep: '/api/DashboardTwo/GetParticipantNamesPerDep',
	GetDashboardTwoPrecedentCategoryTwoCounts: '/api/DashboardTwo/GetPrecedentCategoryTwoCounts',
	GetDashboardTwoStatusCounts: '/api/DashboardTwo/GetDocumentStatusCount',
	GetDashboardTwoRecommendationDetails: '/api/DashboardTwo/GetRecommendationDetails',
	GetDashboardTwoDocumentDetails: '/api/DashboardTwo/GetDocumentDetails',
	GetDashboardTwoDocumentPomDetails: '/api/DashboardTwo/GetDocumentPomDetails',
	GetDashboardTwoDocumentWorkFlowDetails: '/api/DashboardTwo/GetDocumentWorkFlowDetails',
	GetDashboardTwoParticipationMinutesPerDep: '/api/DashboardTwo/GetParticipationMinutesPerDep',
	GetDashboardTwoPrecedentCategoryTwoMonthlyCounts: '/api/DashboardTwo/GetPrecedentCategoryTwoMonthlyCounts',
	GetDashboardTwoFilterDropDownValues: '/api/DashboardTwo/GetDashboardTwoFilterDropDownValues',
	GetDashboardTwoDashboardSubject: '/api/DashboardTwo/GetDashboardSubject',
	ExportDashboardTwoPrecedentDashboardData: '/api/DashboardTwo/ExportPrecedentDashboardData',
	GetDashboardTwoParticipantPerDocument: '/api/DashboardTwo/GetDashboardTwoParticipantPerDocument',
	GetDashboardThreeParticipantPerDocument: '/api/DashboardThree/GetDashboardThreeParticipantPerDocument',
	GetDashboardThreeCounts: '/api/DashboardThree/GetDashboardThreeCounts',
	GetDashboardThreeRecommendationsCount: '/api/DashboardThree/GetDashboardThreeRecommendationsCount',
	GetDashboardThreeParticipantNamesPerDep: '/api/DashboardThree/GetDashboardThreeParticipantNamesPerDep',
	GetDashboardThreePrecedentCategoryTwoCounts: '/api/DashboardThree/GetDashboardThreePrecedentCategoryTwoCounts',
	GetDashboardThreeStatusCount: '/api/DashboardThree/GetDashboardThreeStatusCount',
	GetDashboardThreeRecommendationDetails: '/api/DashboardThree/GetDashboardThreeRecommendationDetails',
	GetDashboardThreeDocumentDetails: '/api/DashboardThree/GetDashboardThreeDocumentDetails',
	GetDashboardThreeDocumentPomDetails: '/api/DashboardThree/GetDashboardThreeDocumentPomDetails',
	GetDashboardThreeDocumentWorkFlowDetails: '/api/DashboardThree/GetDashboardThreeDocumentWorkFlowDetails',
	GetDashboardThreeParticipationMinutesPerDep: '/api/DashboardThree/GetDashboardThreeParticipationMinutesPerDep',
	GetDashboardThreePrecedentCategoryTwoMonthlyCounts: '/api/DashboardThree/GetDashboardThreePrecedentCategoryTwoMonthlyCounts',
	GetDashboardThreePrecedentDashboardFilterDropDownValues: '/api/DashboardThree/GetDashboardThreePrecedentDashboardFilterDropDownValues',
	GetDashboardThreeSubject: '/api/DashboardThree/GetDashboardThreeSubject',
	ExportDashboardThreeData: '/api/DashboardThree/ExportDashboardThreeData',
	GetDashboardThreeDocumentCountPerEmployee: '/api/DashboardThree/GetDashboardThreeDocumentCountPerEmployee',
	GetCountDashboardThreeEmployeeResponsibleTranslations: '/api/DashboardThree/GetCountDashboardThreeEmployeeResponsibleTranslations',
	ExportDashboardThreeDocumentWorkFlowDetails: '/api/DashboardThree/ExportDashboardThreeDocumentWorkFlowDetails',
	getAllLookUps: '/api/Lookup/getList',
	createNewLookup: '/api/Lookup/createLookUp',
	updateLookUpName: '/api/Lookup/updateLookUp',
	getLookUpByID: '/api/Lookup/getById',
	deleteLookUp: '/api/Lookup/deleteLookUP',
	lookupDetailsById: '/api/Lookup/getByIdLookUpDetails',
	ceateLookupDetails: '/api/Lookup/createLookUpDetails ',
	getLookupdetailsById: '/api/Lookup/getLookupdetailsById',
	updateLookUpDetails: '/api/Lookup/updateLookUpDetails',
	UpdateLookUpDetailsDefaultValue:'/api/Lookup/UpdateLookUpDetailsDefaultValue/',
	deleteLookUpDetails: '/api/Lookup/deleteLookUpDetails',

	Dashboard_Analytics: {
		FileStatistics: "/api/File/FileStatistics", //GET
		FileCountByUser: "/api/File/FileCountByUser", //POST,
		TopMaxQuestionsWithStatus: "/api/File/TopMaxQuestionsWithStatus", //Bar chart GET

	},

	//File upload
	saveFile: '/api/File/SaveFile',
	GetDrawingTypesLookUp: '/api/Lookup/getDetailsByLookupId/dt',
	GetAllFileList: '/api/File/getList',
	UpdateFile: '/api/File/updatefile',
	DeleteFile: '/api/File/deletefile/',
	GetFileById: '/api/File/getfileById/',
	GetFileFromCloud: '/api/File/GetFileFromCloud/',
	TriggerAIAnalysis: "/api/File/TriggerAIAnalysis/",
	GetCommentById: '/api/File/CommentCount/',
	ReUpload: "/api/File/ReUpload",
	GetFilesHierarchyById: "/api/File/GetFilesHierarchyById",
	documentControlList:"/api/Lookup/getDetailsByLookupId/",
	UserManagement:{
		GetAllFilesByCurrentUser:"/api/File/GetAllFilesByCurrentUser"
	},


	//Questionnaire
	QuestionaryUrls: {
		CREATE: "/api/Questionnaire/createQuestionnaire",
		UPDATE: "/api/Questionnaire/updateQuestionnaire/",
		DELETE: "/api/Questionnaire/deleteQuestionnaire/",
		GET: "/api/Questionnaire/getList",
		GET_BYID: "/api/Questionnaire/getById",
		getQuestionnaireDetails: "/api/Questionnaire/getQuestionnaireDetails/"
	},
	QuestionUrls: {
		CREATE: "/api/Questionnaire/createQuestion",
		UPDATE: '/api/Questionnaire/updateQuestion/',
		DELETE: '/api/Questionnaire/deleteQuestion/'
	},
	Comments: {
		GET: "/api/Comment/GetbyFileId/",
		CREATE: "/api/Comment/createComment",
		UPDATE: "/api/Comment/updateComment/",
		DELETE: "/api/Comment/deleteComment/"
	},
	Chat: {
		"SEND_QUESTION": "/api/Chat/SendQuestion",
	},
	ArchitecturalDeatil: {
		GET: "/api/File/GetFIleAIReport/",
		getAnalyzedQuestionnaireByFileId: "/api/Questionnaire/getAnalyzedQuestionnaireByFileId",
		getAnalyzedQAByFileId: "/api/Questionnaire/getAnalyzedQAByFileId",
		getNonApprovedAnalysisReport: "/api/Questionnaire/getNonApprovedAnalysisReport/",
	},

	ShareDocument:{
		shareDoc:"/api/Share/shareDocument",
		getDocSharedByUserWithME:"/api/Share/getDocSharedByUser",
		getDocSharedByMe:"/api/Share/getDocSharedByMe",
		unshare:"/api/Share/revertSharedDocument"
	},
	
	Dashboard: {
		GetAllFilesByCurrentUser: "/api/File/GetAllFilesByCurrentUser"
	},
	resetUserPassword: '/api/Auth/ChangePassword',
	logList: "/api/SystemLogs/GetSystemLogsByUser"
}
